import { PERMISSIONS } from "@/utils/constants";
import authMiddleware from "@/router/middlewares/authMiddleware";
import permissionMiddleware from "@/router/middlewares/permissionMiddleware";

export default [
  {
    path: "/reference-product-group",
    name: "product-group",
    component: () => import("../pages/admin/reference/product-group"),
    meta: {
      middleware: [authMiddleware, permissionMiddleware(PERMISSIONS.REFERENCE)],
    },
  },
  {
    path: "/reference-products",
    name: "reference-products",
    component: () => import("../pages/admin/reference/product"),
    meta: {
      middleware: [authMiddleware, permissionMiddleware(PERMISSIONS.PRODUCT)],
    },
  },
  {
    path: "/reference-attributes",
    name: "reference-attributes",
    component: () => import("../pages/admin/reference/attribute"),
    meta: {
      middleware: [authMiddleware, permissionMiddleware(PERMISSIONS.REFERENCE)],
    },
  },
  {
    path: "/reference-departments",
    name: "reference-departments",
    component: () => import("../pages/admin/reference/department"),
    meta: {
      middleware: [authMiddleware, permissionMiddleware(PERMISSIONS.REFERENCE)],
    },
  },
  {
    path: "/product-category",
    name: "product-category",
    component: () => import("../pages/admin/reference/product-category"),
    meta: {
      middleware: [authMiddleware, permissionMiddleware(PERMISSIONS.REFERENCE)],
    },
  },
  {
    path: "/reference-suppliers",
    name: "reference-suppliers",
    component: () => import("../pages/admin/reference/supplier"),
    meta: {
      middleware: [authMiddleware, permissionMiddleware(PERMISSIONS.REFERENCE)],
    },
  },
  {
    path: "/reference-roles",
    name: "reference-roles",
    component: () => import("../pages/admin/reference/role"),
    meta: {
      middleware: [authMiddleware, permissionMiddleware(PERMISSIONS.REFERENCE)],
    },
  },
  {
    path: "/reference-permissions",
    name: "reference-permissions",
    component: () => import("../pages/admin/reference/permission"),
    meta: {
      middleware: [authMiddleware, permissionMiddleware(PERMISSIONS.REFERENCE)],
    },
  },
  {
    path: "/reference-columns",
    name: "reference-columns",
    component: () => import("../pages/admin/reference/column"),
    meta: {
      middleware: [authMiddleware, permissionMiddleware(PERMISSIONS.REFERENCE)],
    },
  },
  {
    path: "/warehouse",
    name: "reference-warehouse",
    component: () => import("../pages/admin/reference/warehouse/index"),
    meta: {
      middleware: [authMiddleware, permissionMiddleware(PERMISSIONS.REFERENCE)],
    },
  },
  {
    path: "/warehouse/view/:id",
    name: "reference-warehouse-view",
    props: true,
    component: () => import("../pages/admin/reference/warehouse/view"),
    meta: {
      middleware: [authMiddleware, permissionMiddleware(PERMISSIONS.REFERENCE)],
    },
  },
  // {
  //   path: "/zone",
  //   name: "zone",
  //   props: true,
  //   component: () => import("../pages/admin/warehouse/zone.vue"),
  //   meta: {
  //     middleware: [authMiddleware, permissionMiddleware(PERMISSIONS.REFERENCE)],
  //   },
  // },
  {
    path: "/product-placement",
    name: "product-placement",
    props: true,
    component: () => import("../components/omtk/ProductPlacement.vue"),
    meta: {
      middleware: [authMiddleware],
    },
  },

  {
    path: "/warehouse/edit/:id",
    name: "reference-warehouse-edit",
    props: true,
    component: () => import("../pages/admin/reference/warehouse/edit"),
    meta: {
      middleware: [
        authMiddleware,
        permissionMiddleware(PERMISSIONS.WAREHOUSE_CREATE),
      ],
    },
  },
  {
    path: "/warehouse/:warehouseId/edit/:cellId/stillage/:columnId",
    name: "reference-warehouse-edit-stillage",
    props: true,
    component: () => import("../pages/admin/reference/warehouse/stillage"),
    meta: {
      middleware: [
        authMiddleware,
        permissionMiddleware(PERMISSIONS.WAREHOUSE_CREATE),
      ],
    },
  },
  {
    path: "/unit-type",
    name: "reference-unit-type",
    component: () => import("../pages/admin/reference/unit-type"),
    meta: {
      middleware: [authMiddleware, permissionMiddleware(PERMISSIONS.REFERENCE)],
    },
  },
  {
    path: "/customer",
    name: "reference-customer",
    component: () => import("../pages/admin/reference/customer"),
    meta: {
      middleware: [authMiddleware, permissionMiddleware(PERMISSIONS.REFERENCE)],
    },
  },
  {
    path: "/product",
    name: "products",
    component: () => import("../pages/admin/reference/product"),
    meta: {
      middleware: [authMiddleware, permissionMiddleware(PERMISSIONS.REFERENCE)],
    },
  },
  {
    path: "/reindex",
    name: "reindex",
    component: () => import("../pages/admin/reference/reindex"),
  },
  {
    path: "/settings",
    name: "settings",
    component: () => import("../pages/admin/settings.vue"),
    meta: {
      middleware: [authMiddleware, permissionMiddleware(PERMISSIONS.SETTINGS)],
    },
  },
];
